module.exports = __webpack_public_path__ + "img/bianzu9.38795d99.png";